(function () {
  'use strict';

  if (window.CouchPotatoProductPage) {
    window.CouchPotatoProductPage.initialize(document);
    return;
  }

  var instances = new WeakMap();

  function parseJson(root) {
    var element = root.querySelector('[data-cp-variant-data]');

    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('Product page variant data could not be parsed.', error);
      return null;
    }
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    return (Number(cents || 0) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
    });
  }

  function focusableElements(container) {
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function ProductPage(root) {
    this.root = root;
    this.data = parseJson(root);
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
    this.productId = this.data ? String(this.data.productId) : root.dataset.cpProductId;
    this.variants = this.data ? this.data.variants : [];
    this.currentVariant = this.findVariant(this.data && this.data.selectedVariantId);
    this.addButton = root.querySelector('[data-product-submit]');
    this.quantityInput = root.querySelector('[data-cp-quantity]');
    this.mobileBar = root.querySelector('[data-cp-mobile-bar]');
    this.stickyButton = root.querySelector('[data-cp-sticky-submit]');
    this.dialog = root.querySelector('[data-cp-size-guide]');
    this.lastFocusedElement = null;
    this.touchStartX = null;
    this.touchStartY = null;

    this.bindOptions();
    this.bindQuantity();
    this.bindAccordions();
    this.bindStickyInfo();
    this.bindSizeGuide();
    this.bindGallery();
    this.bindMobileBar();
    this.bindFormStatus();
    this.bindVariantEvents();

    if (this.currentVariant) {
      this.updateVariant(this.currentVariant);
    }
  }

  ProductPage.prototype.findVariant = function (id) {
    var targetId = String(id || '');

    return this.variants.find(function (variant) {
      return String(variant.id) === targetId;
    }) || this.variants[0] || null;
  };

  ProductPage.prototype.bindVariantEvents = function () {
    var self = this;

    if (!window.jQuery) return;

    this.eventNamespace = '.cpProduct' + this.productId;
    window.jQuery(window)
      .off('shopify-variants:switch-variant' + this.eventNamespace)
      .on('shopify-variants:switch-variant' + this.eventNamespace, function (event, payload) {
        if (!payload || !payload.product || String(payload.product.id) !== self.productId) return;

        var variant = self.findVariant(payload.variant && payload.variant.id);
        if (variant) self.updateVariant(variant);
      });
  };

  ProductPage.prototype.bindOptions = function () {
    var self = this;
    var inputs = this.root.querySelectorAll('[data-product-option]');

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        window.requestAnimationFrame(function () {
          self.updateSelectedOptionLabels();
        });
      }, { signal: self.signal });
    });

    this.updateSelectedOptionLabels();
  };

  ProductPage.prototype.updateSelectedOptionLabels = function () {
    this.root.querySelectorAll('[data-cp-option-group]').forEach(function (group) {
      var selected = group.querySelector('[data-product-option]:checked');
      var output = group.querySelector('[data-cp-selected-option]');
      if (selected && output) output.textContent = selected.value;
    });
  };

  ProductPage.prototype.bindQuantity = function () {
    var self = this;

    if (!this.quantityInput) return;

    this.root.querySelectorAll('[data-cp-quantity-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = Number(button.dataset.cpQuantityChange);
        var step = Number(self.quantityInput.step) || 1;
        var value = Number(self.quantityInput.value);
        if (!Number.isFinite(value)) value = Number(self.quantityInput.min) || 1;

        self.quantityInput.value = value + (direction * step);
        self.normalizeQuantity();
        self.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }, { signal: self.signal });
    });

    this.quantityInput.addEventListener('change', function () {
      self.normalizeQuantity();
    }, { signal: this.signal });

    this.quantityInput.addEventListener('blur', function () {
      self.normalizeQuantity();
    }, { signal: this.signal });
  };

  ProductPage.prototype.normalizeQuantity = function () {
    if (!this.quantityInput) return;

    var min = Number(this.quantityInput.min) || 1;
    var max = this.quantityInput.max === '' ? null : Number(this.quantityInput.max);
    var step = Number(this.quantityInput.step) || 1;
    var value = Number(this.quantityInput.value);

    if (!Number.isFinite(value)) value = min;
    value = min + (Math.round((value - min) / step) * step);
    value = Math.max(min, value);
    if (Number.isFinite(max)) value = Math.min(max, value);

    this.quantityInput.value = value;

    var decrease = this.root.querySelector('[data-cp-quantity-change="-1"]');
    var increase = this.root.querySelector('[data-cp-quantity-change="1"]');
    if (decrease) decrease.disabled = value <= min;
    if (increase) increase.disabled = Number.isFinite(max) && value >= max;
  };

  ProductPage.prototype.updateQuantityRules = function (variant) {
    if (!this.quantityInput) return;

    var rule = variant.quantityRule || {};
    var min = Number(rule.min) || 1;
    var increment = Number(rule.increment) || 1;
    var max = rule.max === null || rule.max === '' || typeof rule.max === 'undefined'
      ? null
      : Number(rule.max);

    this.quantityInput.min = min;
    this.quantityInput.step = increment;
    if (Number.isFinite(max)) {
      this.quantityInput.max = max;
    } else {
      this.quantityInput.removeAttribute('max');
    }

    var rules = this.root.querySelector('[data-cp-quantity-rules]');
    var minOutput = this.root.querySelector('[data-cp-quantity-min]');
    var incrementOutput = this.root.querySelector('[data-cp-quantity-increment]');
    var maxOutput = this.root.querySelector('[data-cp-quantity-max]');

    if (minOutput) minOutput.textContent = 'Minimum ' + min;

    if (incrementOutput) {
      incrementOutput.textContent = 'In increments of ' + increment;
      incrementOutput.classList.toggle('hidden', increment === 1);
    }

    if (maxOutput) {
      maxOutput.textContent = Number.isFinite(max) ? 'Maximum ' + max : '';
      maxOutput.classList.toggle('hidden', !Number.isFinite(max));
    }

    if (rules) {
      rules.classList.toggle('hidden', min === 1 && increment === 1 && !Number.isFinite(max));
    }

    var volumePricing = this.root.querySelector('[data-cp-volume-pricing]');
    var volumePricingList = this.root.querySelector('[data-cp-volume-pricing-list]');
    var priceBreaks = variant.quantityPriceBreaks || [];

    if (volumePricing && volumePricingList) {
      volumePricingList.innerHTML = '';

      priceBreaks.forEach(function (priceBreak) {
        var item = document.createElement('li');
        var quantity = document.createElement('span');
        var price = document.createElement('span');
        quantity.textContent = priceBreak.minimumQuantity + '+';
        price.innerHTML = formatMoney(priceBreak.price, this.data.moneyFormat) + ' each';
        item.appendChild(quantity);
        item.appendChild(price);
        volumePricingList.appendChild(item);
      }, this);

      volumePricing.classList.toggle('hidden', priceBreaks.length === 0);
    }

    this.normalizeQuantity();
  };

  ProductPage.prototype.bindAccordions = function () {
    var self = this;

    this.root.querySelectorAll('[data-cp-accordion-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(button.getAttribute('aria-controls'));

        button.setAttribute('aria-expanded', String(!expanded));
        if (panel) panel.hidden = expanded;
        self.updateStickyInfo();
      }, { signal: self.signal });
    });
  };

  ProductPage.prototype.bindStickyInfo = function () {
    var self = this;
    if (!this.root.classList.contains('cp-product--sticky-info')) return;

    this.stickyDetails = this.root.querySelector('.cp-product__details');
    if (!this.stickyDetails) return;

    window.addEventListener('resize', function () {
      self.updateStickyInfo();
    }, { passive: true, signal: this.signal });

    if ('ResizeObserver' in window) {
      this.stickyResizeObserver = new ResizeObserver(function () {
        self.updateStickyInfo();
      });
      this.stickyResizeObserver.observe(this.stickyDetails);
    }

    this.updateStickyInfo();
  };

  ProductPage.prototype.updateStickyInfo = function () {
    if (!this.stickyDetails) return;

    var canStick = window.innerWidth >= 990 &&
      this.stickyDetails.scrollHeight <= Math.max(0, window.innerHeight - 48);
    this.root.classList.toggle('cp-product--sticky-active', canStick);
  };

  ProductPage.prototype.bindSizeGuide = function () {
    var self = this;
    if (!this.dialog) return;

    this.root.querySelectorAll('[data-cp-size-guide-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.openSizeGuide(button);
      }, { signal: self.signal });
    });

    this.dialog.querySelectorAll('[data-cp-size-guide-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.closeSizeGuide();
      }, { signal: self.signal });
    });

    document.addEventListener('keydown', function (event) {
      if (self.dialog.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        self.closeSizeGuide();
        return;
      }

      if (event.key !== 'Tab') return;

      var elements = focusableElements(self.dialog);
      if (!elements.length) {
        event.preventDefault();
        return;
      }

      var first = elements[0];
      var last = elements[elements.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }, { signal: this.signal });
  };

  ProductPage.prototype.openSizeGuide = function (trigger) {
    var panel = this.dialog.querySelector('[data-cp-size-guide-panel]');
    this.lastFocusedElement = trigger;
    this.dialog.hidden = false;
    document.body.classList.add('cp-product-dialog-open');
    var elements = focusableElements(this.dialog);
    if (elements.length) {
      elements[0].focus();
    } else if (panel) {
      panel.focus();
    }
  };

  ProductPage.prototype.closeSizeGuide = function () {
    this.dialog.hidden = true;
    document.body.classList.remove('cp-product-dialog-open');
    if (this.lastFocusedElement) this.lastFocusedElement.focus();
  };

  ProductPage.prototype.bindGallery = function () {
    var self = this;
    var viewport = this.root.querySelector('[data-product-gallery-viewport]');
    var figures = this.root.querySelectorAll('[data-product-gallery-figure]');

    this.bindThumbnailRail();

    if (!viewport || figures.length < 2) return;

    this.galleryObserver = new MutationObserver(function () {
      self.updateGalleryState();
    });

    this.galleryObserver.observe(this.root.querySelector('[data-product-gallery]'), {
      attributes: true,
      attributeFilter: ['data-product-gallery-selected'],
      subtree: true
    });

    this.root.querySelectorAll('[data-cp-gallery-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.selectGalleryIndex(Number(dot.dataset.cpGalleryDot));
      }, { signal: self.signal });
    });

    viewport.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1 || event.target.closest('button, a, video, iframe, model-viewer')) return;
      self.touchStartX = event.touches[0].clientX;
      self.touchStartY = event.touches[0].clientY;
    }, { passive: true, signal: this.signal });

    viewport.addEventListener('touchend', function (event) {
      if (self.touchStartX === null || !event.changedTouches.length) return;

      var deltaX = event.changedTouches[0].clientX - self.touchStartX;
      var deltaY = event.changedTouches[0].clientY - self.touchStartY;
      self.touchStartX = null;
      self.touchStartY = null;

      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

      var current = self.currentGalleryIndex();
      self.selectGalleryIndex(deltaX < 0 ? current + 1 : current - 1);
    }, { passive: true, signal: this.signal });

    viewport.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      var current = self.currentGalleryIndex();
      self.selectGalleryIndex(event.key === 'ArrowRight' ? current + 1 : current - 1);
    }, { signal: this.signal });

    this.updateGalleryState();
  };

  ProductPage.prototype.bindThumbnailRail = function () {
    var self = this;
    var rail = this.root.querySelector('[data-cp-thumbnail-rail]');
    var scroller = this.root.querySelector('[data-cp-thumbnail-viewport]');

    if (!rail || !scroller) return;

    var previous = rail.querySelector('[data-cp-thumbnail-scroll="-1"]');
    var next = rail.querySelector('[data-cp-thumbnail-scroll="1"]');

    function updateState() {
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      var maxScroll = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      var isScrollable = isDesktop && maxScroll > 2;

      rail.classList.toggle('is-scrollable', isScrollable);
      if (previous) previous.disabled = !isScrollable || scroller.scrollTop <= 1;
      if (next) next.disabled = !isScrollable || scroller.scrollTop >= maxScroll - 1;
    }

    rail.querySelectorAll('[data-cp-thumbnail-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = Number(button.dataset.cpThumbnailScroll);
        var thumbnails = scroller.querySelectorAll('[data-product-gallery-thumbnail]');
        var step = thumbnails.length > 1
          ? Math.abs(thumbnails[1].offsetTop - thumbnails[0].offsetTop)
          : (thumbnails[0] ? thumbnails[0].offsetHeight : 80);

        scroller.scrollTo({
          top: scroller.scrollTop + (direction * Math.max(step, 1)),
          behavior: 'smooth'
        });
      }, { signal: self.signal });
    });

    scroller.addEventListener('scroll', updateState, { passive: true, signal: this.signal });
    window.addEventListener('resize', updateState, { passive: true, signal: this.signal });
    this.updateThumbnailRailState = updateState;
    window.requestAnimationFrame(updateState);
  };

  ProductPage.prototype.currentGalleryIndex = function () {
    var selected = this.root.querySelector('[data-product-gallery-figure][data-product-gallery-selected="true"]');
    return selected ? Number(selected.dataset.productGalleryFigure) : 0;
  };

  ProductPage.prototype.selectGalleryIndex = function (index) {
    var count = this.root.querySelectorAll('[data-product-gallery-figure]').length;
    var boundedIndex = Math.max(0, Math.min(count - 1, index));
    var thumbnail = this.root.querySelector('[data-product-gallery-thumbnail="' + boundedIndex + '"]');

    if (thumbnail) thumbnail.click();
  };

  ProductPage.prototype.updateGalleryState = function () {
    var current = this.currentGalleryIndex();
    var output = this.root.querySelector('[data-cp-gallery-current]');
    if (output) output.textContent = current + 1;

    this.root.querySelectorAll('[data-cp-gallery-dot]').forEach(function (dot) {
      dot.setAttribute('aria-current', String(Number(dot.dataset.cpGalleryDot) === current));
    });

    var selectedThumbnail = this.root.querySelector('[data-product-gallery-thumbnail="' + current + '"]');
    if (selectedThumbnail) {
      selectedThumbnail.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: window.matchMedia('(max-width: 989px)').matches ? 'center' : 'nearest'
      });
    }

    if (this.updateThumbnailRailState) {
      window.setTimeout(this.updateThumbnailRailState, 220);
    }
  };

  ProductPage.prototype.bindMobileBar = function () {
    var self = this;
    if (!this.mobileBar) return;

    document.body.classList.add('cp-has-mobile-sticky');

    if (this.stickyButton && this.addButton) {
      this.stickyButton.addEventListener('click', function () {
        if (!self.addButton.disabled) self.addButton.click();
      }, { signal: this.signal });

      if ('IntersectionObserver' in window) {
        this.stickyVisibilityObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            self.mobileBar.classList.toggle('is-hidden', entry.isIntersecting);
          });
        }, { threshold: 0.35 });
        this.stickyVisibilityObserver.observe(this.addButton);
      }
    }
  };

  ProductPage.prototype.bindFormStatus = function () {
    var self = this;
    var form = this.root.querySelector('[data-product-form]');

    if (this.addButton) {
      this.buttonObserver = new MutationObserver(function () {
        var isLoading = self.addButton.classList.contains('addtocart-button-loading');
        self.addButton.setAttribute('aria-busy', String(isLoading));
        self.syncMobileButton();
      });
      this.buttonObserver.observe(this.addButton, {
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });
      this.addButton.setAttribute('aria-busy', 'false');
    }

    if (form) {
      this.formObserver = new MutationObserver(function () {
        form.querySelectorAll('.error-message').forEach(function (error) {
          error.setAttribute('role', 'alert');
        });
      });
      this.formObserver.observe(form, { childList: true });
    }
  };

  ProductPage.prototype.syncMobileButton = function () {
    if (!this.stickyButton || !this.addButton) return;
    var isLoading = this.addButton.classList.contains('addtocart-button-loading');
    this.stickyButton.disabled = this.addButton.disabled || isLoading;
    this.stickyButton.classList.toggle('is-loading', isLoading);
  };

  ProductPage.prototype.updateVariant = function (variant) {
    this.currentVariant = variant;
    this.updateSelectedOptionLabels();
    this.updateQuantityRules(variant);

    var labels = this.data.labels;
    var effectiveAvailability = variant.available && this.data.countryAvailable;
    var addLabel = this.data.countryAvailable
      ? (variant.available ? labels.addToCart : labels.soldOut)
      : labels.countryUnavailable;
    var addLabelOutput = this.root.querySelector('[data-cp-add-label]');
    var addPriceOutput = this.root.querySelector('[data-cp-add-price]');
    var addSeparator = this.root.querySelector('[data-cp-add-separator]');
    var stickyPrice = this.root.querySelector('[data-cp-sticky-price]');

    if (addLabelOutput) addLabelOutput.textContent = addLabel;
    if (addPriceOutput) addPriceOutput.innerHTML = formatMoney(variant.price, this.data.moneyFormat);
    if (addPriceOutput) addPriceOutput.classList.toggle('hidden', !effectiveAvailability);
    if (addSeparator) addSeparator.classList.toggle('hidden', !effectiveAvailability);
    if (stickyPrice) stickyPrice.innerHTML = formatMoney(variant.price, this.data.moneyFormat);

    if (this.addButton) {
      this.addButton.disabled = !effectiveAvailability;
      this.addButton.classList.toggle('disabled', !effectiveAvailability);
    }

    if (this.stickyButton) {
      this.stickyButton.disabled = !effectiveAvailability;
      this.stickyButton.textContent = addLabel;
    }

    var discount = this.root.querySelector('[data-cp-discount]');
    var isOnSale = Number(variant.compareAtPrice) > Number(variant.price);

    if (discount) {
      if (isOnSale) {
        var percent = Math.round(((variant.compareAtPrice - variant.price) / variant.compareAtPrice) * 100);
        discount.textContent = percent + '% off';
      } else {
        discount.textContent = '';
      }
      discount.classList.toggle('hidden', !isOnSale);
    }

    var stock = this.root.querySelector('[data-cp-stock-status]');
    var stockDot = this.root.querySelector('[data-cp-stock-dot]');
    var threshold = Number(this.data.lowStockThreshold || 5);
    var stockText = this.data.countryAvailable ? labels.soldOut : labels.countryUnavailable;

    if (effectiveAvailability) {
      if (
        variant.inventoryManagement &&
        Number(variant.inventoryQuantity) <= 0 &&
        variant.inventoryPolicy === 'continue'
      ) {
        stockText = labels.availableToOrder;
      } else if (
        this.data.showLowStockCount &&
        variant.inventoryManagement &&
        Number(variant.inventoryQuantity) > 0 &&
        Number(variant.inventoryQuantity) <= threshold
      ) {
        stockText = labels.onlyLeft.replace('[quantity]', variant.inventoryQuantity);
      } else {
        stockText = labels.inStock;
      }
    }

    if (stock) stock.textContent = stockText;
    if (stockDot) stockDot.classList.toggle('cp-product__availability-dot--unavailable', !effectiveAvailability);

    this.syncMobileButton();
  };

  ProductPage.prototype.destroy = function () {
    this.abortController.abort();

    if (this.galleryObserver) this.galleryObserver.disconnect();
    if (this.buttonObserver) this.buttonObserver.disconnect();
    if (this.formObserver) this.formObserver.disconnect();
    if (this.stickyVisibilityObserver) this.stickyVisibilityObserver.disconnect();
    if (this.stickyResizeObserver) this.stickyResizeObserver.disconnect();

    if (window.jQuery && this.eventNamespace) {
      window.jQuery(window).off(this.eventNamespace);
    }

    if (this.dialog && !this.dialog.hidden) {
      document.body.classList.remove('cp-product-dialog-open');
    }

    if (this.mobileBar) {
      document.body.classList.remove('cp-has-mobile-sticky');
    }

    instances.delete(this.root);
  };

  function initialize(container) {
    var roots = [];

    if (container.matches && container.matches('[data-cp-product]')) roots.push(container);
    if (container.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(container.querySelectorAll('[data-cp-product]')));
    }

    roots.forEach(function (root) {
      if (!instances.has(root)) instances.set(root, new ProductPage(root));
    });
  }

  function initializeDocument() {
    initialize(document);
  }

  window.CouchPotatoProductPage = {
    initialize: initialize
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDocument, { once: true });
  } else {
    initializeDocument();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector && event.target.querySelector('[data-cp-product]');
    if (root && instances.has(root)) instances.get(root).destroy();
  });
})();
